export const UPDATE_VIEWPORT_CATEGORY = "update-viewport-category";
export const SMALL_VIEWPORT = "small-viewport";
export const MEDIUM_VIEWPORT = "medium-viewport";
export const LARGE_VIEWPORT = "large-viewport";
export const CLOSE_SIDE_PANEL = "CLOSE_SIDE_PANEL";
export const OPEN_SIDE_PANEL = "OPEN_SIDE_PANEL";
export const SET_GENDER = "SET_GENDER";
export const MALE = "men";
export const FEMALE = "women";
export const DEFAULT = "default";
export const SECURE = "secure";
export const OPEN_COOKIE_MESSAGE = "OPEN_COOKIE_MESSAGE";
export const CLOSE_COOKIE_MESSAGE = "CLOSE_COOKIE_MESSAGE";
export const SET_GEO_COUNTRY = "SET_GEO_COUNTRY";
